import axios from 'axios';
import type { IRecentSearchHistory } from '@bb/domain/dist/types';

const addListingToHistory = async (
  listingId: string,
  takingFavoriteAction?: boolean,
) => {
  const { data } = await axios.post<IRecentSearchHistory>(
    `/search/recents/listings/${listingId}`,
    {
      takingFavoriteAction,
    },
  );
  return data;
};

export default addListingToHistory;
